module.exports = __webpack_public_path__ + "img/britain.5aad7f43.png";